import { Pipe } from '@angular/core';
import { isArray, isDeepObject, unwrapDeep, deepIndexOf } from '../utils/utils';
var UniqPipe = (function () {
    function UniqPipe() {
    }
    UniqPipe.prototype.transform = function (input) {
        if (!isArray(input) && !isDeepObject(input)) {
            return input;
        }
        if (isDeepObject(input)) {
            var unwrappedInput_1 = unwrapDeep(input);
            if (!isArray(unwrappedInput_1)) {
                return unwrappedInput_1;
            }
            return unwrappedInput_1.filter(function (value, index) {
                return deepIndexOf(unwrappedInput_1, value) === index;
            });
        }
        return input.filter(function (value, index) { return input.indexOf(value) === index; });
    };
    return UniqPipe;
}());
export { UniqPipe };
UniqPipe.decorators = [
    { type: Pipe, args: [{
                name: 'uniq'
            },] },
];
/** @nocollapse */
UniqPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=uniq.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/uniq.pipe.js
// module id = 253
// module chunks = 103